import React, {  useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { ReactComponent as Logo } from '../assets/images/logo.svg'; // Import your SVG logo
import { FaArrowLeft, FaGoogle } from "react-icons/fa";
import { loginAdmin, loginWithGoogle } from '../utils/adminAuth';

const CustomAppBargd = ({ onMenuClick }) => {
  const navigate = useNavigate();
  const [showAdminDialog, setShowAdminDialog] = useState(false);
  const [adminEmail, setAdminEmail] = useState('');
  const [adminPassword, setAdminPassword] = useState('');
  const [isVerifying, setIsVerifying] = useState(false);

  const handleAdminAccess = async () => {
    if (!adminEmail.trim() || !adminPassword.trim()) {
      alert('Please enter email and password');
      return;
    }

    setIsVerifying(true);
    try {
      const isValid = await loginAdmin(adminEmail, adminPassword);
      if (isValid) {
        sessionStorage.setItem('adminAuthenticated', 'true');
        navigate('/AdminHomeScreen'); // Navigate to the admin home screen
        setShowAdminDialog(false);
        setAdminEmail('');
        setAdminPassword('');
      } else {
        alert('Incorrect login details');
      }
    } catch (error) {
      console.error('Error verifying admin password:', error);
      alert('Error verifying admin code. Please try again.');
    } finally {
      setIsVerifying(false);
    }
  };

  const handleGoogleLogin = async () => {
    setIsVerifying(true);
    try {
      await loginWithGoogle();
      // The page will redirect to Google
    } catch (error) {
      console.error('Error logging in with Google:', error);
      alert('Error logging in with Google');
      setIsVerifying(false);
    }
  };

  return (
    <>
      {/* App Bar */}
      <div
        style={{
          backgroundColor: 'black', // Dark gray background
          padding: '10px',
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          position: 'sticky',
          top: 0,
          zIndex: 1000,
          boxShadow: '0 4px 6px rgba(255, 255, 255, 0.2), 0 1px 3px rgba(255, 255, 255, 0.1)'

          // Subtle shadow
        }}
      >
        {/* Left Side: Drawer Icon */}
        <button
          style={{
            backgroundColor: 'transparent',
            border: 'none',
            cursor: 'pointer',
            padding: '8px',
          }}
          onClick={onMenuClick} // Use the onMenuClick prop
          title="return"
        >
          <FaArrowLeft style={{ color: 'white', fontSize: '24px' }} /> {/* Using react-icons */}
        </button>

        {/* Center: Title and Logo */}
        <div
          style={{
            display: 'flex',
            alignItems: 'center',
            gap: '8px',
            position: 'absolute',
            left: '50%',
            transform: 'translateX(-50%)',
          }}
        >
          <h1
            style={{
              color: 'rgba(255, 255, 255, 0.7)',
              fontSize: '20px',
              fontWeight: 'bold',
              margin: 0,
            }}
          >
            GuppyDz
          </h1>
          <div
            style={{ cursor: 'pointer' }}
            onClick={() => setShowAdminDialog(true)}
          >
            <Logo
              style={{
                width: '100px', // Desired container width
                height: '100px', // Desired container height
                objectFit: 'scale-down', // Ensures the SVG scales down without losing content
              }}
            />
          </div>
        </div>

        {/* Right Side: Orders Button */}
        <button
          style={{
            backgroundColor: 'transparent',
            border: 'none',
            cursor: 'pointer',
            padding: '8px',
          }}
          onClick={() => navigate('/OrdersPage')}
          title="View Orders"
        >
          <span style={{ color: 'white', fontSize: '24px' }}>🛍️</span>
        </button>
      </div>

      {/* Admin Access Dialog */}
      {showAdminDialog && (
        <div
          style={{
            position: 'fixed',
            top: 0,
            left: 0,
            width: '100%',
            height: '100%',
            backgroundColor: 'rgba(0, 0, 0, 0.5)',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            zIndex: 1001,
          }}
        >
          <div
            style={{
              backgroundColor: 'white',
              padding: '20px',
              borderRadius: '8px',
              width: '300px',
              textAlign: 'center',
            }}
          >
            <h2>Admin Access</h2>
            <input
              type="email"
              placeholder="Enter Admin Email"
              value={adminEmail}
              onChange={(e) => setAdminEmail(e.target.value)}
              style={{
                width: '100%',
                padding: '10px',
                margin: '10px 0 0 0',
                borderRadius: '4px',
                border: '1px solid #ccc',
              }}
              autoFocus
            />
            <input
              type="password"
              placeholder="Enter Admin Password"
              value={adminPassword}
              onChange={(e) => setAdminPassword(e.target.value)}
              style={{
                width: '100%',
                padding: '10px',
                margin: '10px 0',
                borderRadius: '4px',
                border: '1px solid #ccc',
              }}
            />
            <div style={{ display: 'flex', flexDirection: 'column', gap: '10px' }}>
              <div style={{ display: 'flex', justifyContent: 'space-between', gap: '10px' }}>
                <button
                  style={{
                    backgroundColor: 'red',
                    color: 'white',
                    padding: '8px 16px',
                    border: 'none',
                    borderRadius: '4px',
                    cursor: 'pointer',
                    flex: 1
                  }}
                  onClick={() => {
                    setShowAdminDialog(false);
                    setAdminEmail('');
                    setAdminPassword('');
                  }}
                >
                  Cancel
                </button>
                <button
                  style={{
                    backgroundColor: isVerifying ? '#666' : 'green',
                    color: 'white',
                    padding: '8px 16px',
                    border: 'none',
                    borderRadius: '4px',
                    cursor: isVerifying ? 'wait' : 'pointer',
                    opacity: isVerifying ? 0.7 : 1,
                    flex: 2
                  }}
                  onClick={handleAdminAccess}
                  disabled={isVerifying}
                >
                  {isVerifying ? 'Verifying...' : 'Submit'}
                </button>
              </div>

              <button
                onClick={handleGoogleLogin}
                disabled={isVerifying}
                style={{
                  width: '100%',
                  backgroundColor: 'white',
                  color: '#4285F4',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  gap: '10px',
                  border: '1px solid #4285F4',
                  padding: '10px',
                  borderRadius: '4px',
                  fontWeight: '600',
                  cursor: isVerifying ? 'wait' : 'pointer',
                  opacity: isVerifying ? 0.7 : 1
                }}
              >
                <FaGoogle /> Sign in with Google
              </button>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default CustomAppBargd;